enum MeActionEnum {
  LOAD_ME = 'LOAD_ME',
  LOG_IN = 'LOG_IN',
  LOG_OUT = 'LOG_OUT',
  SELECT_MEMBERSHIP = 'SELECT_MEMBERSHIP',
}

export default MeActionEnum;
